import IconButton from '@alltrails/shared/denali/components/IconButton';
import Directions from '@alltrails/shared/icons/Directions';
import Share from '@alltrails/shared/icons/Share';
import User from '@alltrails/shared/types/User';
import { ReactNode } from 'react';
import UserImageLink from '../UserImageLink';
import MenuPop from '../MenuPop';
import * as styles from './styles/styles.module.scss';
import { useIntl } from '@alltrails/shared/react-intl';

type Props = {
  handleDirectionsClick: () => void;
  handleShareClick: () => void;
  menuItems: { callback: () => void; label: ReactNode }[];
  user: User;
};

const HeaderButtons = ({ user, handleDirectionsClick, handleShareClick, menuItems }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.buttonPanel}>
      <div className={styles.userImage}>
        <UserImageLink user={user} />
      </div>
      <div className={styles.circleIcon}>
        <IconButton
          icon={{ Component: Directions }}
          onClick={handleDirectionsClick}
          title={intl.formatMessage({ defaultMessage: 'Directions' })}
          testId="map-header-directions"
          variant="elevated"
        />
      </div>
      <div className={styles.circleIcon}>
        <IconButton
          icon={{ Component: Share }}
          onClick={handleShareClick}
          title={intl.formatMessage({ defaultMessage: 'Share' })}
          testId="map-header-share"
          variant="elevated"
        />
      </div>
      <MenuPop variant="circle" items={menuItems} />
    </div>
  );
};

export default HeaderButtons;
